import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { CRITERIA_GROUP } from '../constant'
import classes from './index.module.scss'
import { Indicator } from './Indicator'
import { Industry } from './Industry'

export const GroupCriterira = ({ criteriaGroup, groupData, currency }) => {
  const isNoData =
    criteriaGroup === CRITERIA_GROUP.INDUSTRY
      ? !groupData.ids.length && !groupData.listIdCheckedTree.length
      : !Object.values(groupData).filter(Boolean).length

  const renderIndicators = () => {
    const indicators = Object.values(groupData)
      .filter(Boolean)
      .sort((a, b) => a.createdAt - b.createdAt)

    return indicators.map((indicator) => (
      <Indicator
        key={indicator.screeningIndicatorId}
        data={indicator}
        currency={currency}
      />
    ))
  }

  const renderIndustry = () => {
    return <Industry data={groupData} />
  }
  if (isNoData) return null

  return (
    <Element
      className={classes.groupCriteria}
      style={{ borderColor: '#D5D5D5' }}
    >
      <Element className={classes.groupTitle} style={{ fontSize: 14 }}>
        <Translate value={`screening.${criteriaGroup}`} />
        {criteriaGroup === CRITERIA_GROUP.INDUSTRY &&
          ` (${groupData.industryType})`}
      </Element>
      <Element className={classes.conditions} style={{ color: '#3A414B' }}>
        {criteriaGroup === CRITERIA_GROUP.INDUSTRY
          ? renderIndustry()
          : renderIndicators()}
      </Element>
    </Element>
  )
}
